export default "__VITE_PUBLIC_ASSET__b0cb663f__"